import { Navigate } from 'react-router';

export const RedirectHandler = () => {
  return <Navigate to='/auth' replace />;
};
